import { Shield } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { networkPolicyWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  networkPolicyWeb,
  {
    OrganizationSecurityPage: () =>
      import('./OrganizationSecurityPage').then((m) => ({ default: m.OrganizationSecurityPage })),
    NetworkPoliciesPage: () =>
      import('./NetworkPoliciesPage').then((m) => ({ default: m.NetworkPoliciesPage })),
    NetworkPoliciesRedirect: () =>
      import('./NetworkPoliciesRedirect').then((m) => ({ default: m.NetworkPoliciesRedirect })),
    NetworkPolicyOrgSettingsSection: () =>
      import('./NetworkPolicyOrgSettingsSection').then((m) => ({
        default: m.NetworkPolicyOrgSettingsSection,
      })),
    NetworkPolicyAttachmentPicker: () =>
      import('./NetworkPolicyAttachmentPicker').then((m) => ({
        default: m.NetworkPolicyAttachmentPicker,
      })),
    NetworkPolicyAttachmentSummary: () =>
      import('./NetworkPolicyAttachmentSummary').then((m) => ({
        default: m.NetworkPolicyAttachmentSummary,
      })),
    NetworkPolicyDetailSection: () =>
      import('./NetworkPolicyDetailSection').then((m) => ({
        default: m.NetworkPolicyDetailSection,
      })),
    NetworkPolicyPreview: () =>
      import('./NetworkPolicyPreview').then((m) => ({ default: m.NetworkPolicyPreview })),
    NetworkPolicyMentionProvider: () =>
      import('./NetworkPolicyMentionProvider').then((m) => ({
        default: m.NetworkPolicyMentionProvider,
      })),
    NetworkPolicyMentionCreate: () =>
      import('./NetworkPolicyMentionCreate').then((m) => ({
        default: m.NetworkPolicyMentionCreate,
      })),
  },
  { icons: { Shield } },
);
